import axios from "axios";

const API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL ||
  "https://backend-dot-immersely-ai.nw.r.appspot.com/api/v1";

export async function requestPasswordReset(email) {
  const response = await axios.post(`${API_BASE_URL}/auth/forgot-password`, { email });
  return response.data;
}

export async function resetPassword(token, password) {
  const response = await axios.post(`${API_BASE_URL}/auth/reset-password`, { token, password });
  return response.data;
}

export async function registerAccount({ email, password, role }) {
  const response = await axios.post(`${API_BASE_URL}/auth/register`, { email, password, role });
  return response.data;
}

export async function verifyEmail(token) {
  const response = await axios.post(`${API_BASE_URL}/auth/verify-email`, { token });
  return response.data;
}

export async function resendVerification(email) {
  const response = await axios.post(`${API_BASE_URL}/auth/resend-verification`, { email });
  return response.data;
}
